import { useEffect, useState } from 'react';

// import { useRouter } from 'next/router';

import { useMediaQuery } from '@react-hookz/web';
import classNames from 'classnames';
import { getLocation } from 'connected-react-router';
import clamp from 'lodash/clamp';
import throttle from 'lodash/throttle';
import { StickyContainer } from 'react-sticky';

import { SkipToMainContent } from 'src/app/components/Elements/SkipToMainContent';
import Footer from 'src/app/components/Footer/container';
import { NavTheme } from 'src/app/components/Header/constants';
import { LoggedOutHeader } from 'src/app/components/Header/LoggedOutHeader';
// import useExperiments from 'src/app/hooks/useExperiments';
import { LayoutRoutes } from 'src/app/popsicle/router/layoutRoutes';
// import { maintenance } from 'src/app/router/paths';
import { useSelector } from 'src/app/state/store';
import { NAV_HEIGHT } from 'src/consts';
// import { getAnonUserId } from 'src/landing-pages/utils';

import type { PropsFromRedux } from './container';
import styles from './styles.module.scss';

const displayName = 'Marketing';

const mainContentId = 'main-content';

interface MarketingProps extends PropsFromRedux {}

export const MarketingRenderer = ({
  navVariant,
  isFooterShown,
  isNewOnboarding,
  isPromoOnboardingPage,
  isPromoLinkedSuccessfullyPage,
  pathname,
}: MarketingProps) => {
  const location = useSelector(getLocation);
  const [navOpacity, setNavOpacity] = useState(1);
  const [stickyTopOffset, setStickyTopOffset] = useState(0);
  const navColor = NavTheme.white;

  const mdDown = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    // NOTE: prevents transparency carry over on page change
    setNavOpacity(1);
  }, [pathname]);

  // const router = useRouter();
  // const { fetchVariant } = useExperiments();
  // useEffect(() => {
  //   const evaluateMaintenanceModeFlag = async () => {
  //     const maintenanceMode = await fetchVariant({
  //       experimentKey: 'maintenance_mode',
  //       userId: getAnonUserId(),
  //     });

  //     if (maintenanceMode === 'on') {
  //       if (router.asPath !== maintenance.toPath()) {
  //         router.replace(maintenance.toPath());
  //       }
  //     }
  //   };
  //   evaluateMaintenanceModeFlag();
  // }, [fetchVariant, router]);

  useEffect(() => {
    const getScrollDepth = throttle(() => {
      const scroll = window.scrollY || window.pageYOffset;
      const stickyanchor = document.querySelector('#stickyanchor');
      if (stickyanchor) {
        const offsetHeight = (stickyanchor as any).offsetTop;
        setStickyTopOffset(offsetHeight);
        if (scroll < NAV_HEIGHT + 100) {
          setNavOpacity(1);
        } else {
          const navOpacity = clamp(0.5 + (scroll - offsetHeight) * 0.01, 0, 1);
          setNavOpacity(navOpacity);
        }
      }
    }, 100);

    getScrollDepth();
    window.addEventListener('scroll', getScrollDepth);

    return () => {
      window.removeEventListener('scroll', getScrollDepth);
    };
  }, [mdDown]);

  return (
    <StickyContainer>
      <div
        className={classNames({
          [styles.component]: !isNewOnboarding,
          marketing: !isNewOnboarding,
          'layout-marketing': !isNewOnboarding,
        })}
      >
        <div className={classNames({ [styles.content]: !isNewOnboarding })}>
          <SkipToMainContent id={mainContentId} />
          <LoggedOutHeader
            variant={navVariant}
            stickyTopOffset={stickyTopOffset}
            navOpacity={navOpacity}
            navTheme={navColor}
            hasGetStartedLink={!isNewOnboarding}
            hasSignInLink={!isNewOnboarding && !isPromoOnboardingPage && !isPromoLinkedSuccessfullyPage}
          />
          <div id={mainContentId}>
            <LayoutRoutes renderKey="content" displayName={displayName} location={location} />
          </div>
          {isFooterShown && <Footer />}
        </div>
      </div>
    </StickyContainer>
  );
};

MarketingRenderer.displayName = displayName;
